module.exports = __webpack_public_path__ + "static/media/cyrkulacja.41289fa9.svg";